import React, { lazy } from 'react';

const Companies = lazy(() => import('./Company/Companies'));
const AdminSealDocuments = lazy(() => import('./Contract/AdminSealDocuments'));
const Archives = lazy(() => import('./Archive/Archives'));
const Announcements = lazy(() => import('./Announcement/Announcements'));

export const adminPageRoutes = [
  { path: '/admin/company', component: Companies },
  { path: '/admin/contract', component: AdminSealDocuments },
  { path: '/admin/archive', component: Archives },
  { path: '/admin/announcements', component: Announcements }
];

export default adminPageRoutes;
